import { WinePackageWidgetModel } from 'shared-widget-components/src/services/FeaturedPackagesService';
import { truncateHtml } from 'shared-widget-components/src/utils/truncateHtml';

/**
 * The WinePackageDescription component renders the description of a wine package.
 * @param winePackage - The wine package to render.
 * @returns The WinePackageDescription component is returning JSX elements.
 */

export const WinePackageDescription = ({ winePackage }: { winePackage: WinePackageWidgetModel }) => {
  // sanitize and truncate description
  const sanitizedTruncatedDescription = truncateHtml(winePackage.description, 70);

  return (
    <p className={`w-full h-[48px] font-body text-black font-medium min-[350px]:text-[14px] md:text-[16px] ${winePackage.showEurPrice ? 'min-[350px]:mt-0 md:mt-[4px]' : 'min-[350px]:mt-[8px]'}`}>
      {sanitizedTruncatedDescription ?? ''}
    </p>
  );
};
